export const CUSTOM_INTEGRATION_URL =
  'https://leads.vastreach.com/customform/cipost'

export const CUSTOM_INTEGRATION_JSON_URL =
  'https://prxlvz32s7.execute-api.us-east-1.amazonaws.com/prod'

export const OPEN_AI_URL =
  'https://6h8ktz74yg.execute-api.us-east-1.amazonaws.com/prod'

export const DATA_API_URL =
  'https://h8cejqsw7d.execute-api.us-east-1.amazonaws.com/prod'

export const NEXT_GEN_APP_URL = 'https://d26yneq5avlkyv.cloudfront.net'

export { default as FORM_URL } from './FormUrl_prod'
export { default as ACKNOWLEDGEMENT_URL } from './AcknowledgementApiUrl_prod'
export { default as API_URL } from './ApiUrl_prod'
export { default as FILE_URL } from './FileApiUrl_prod'
export { default as LUIS_URL } from './LuisApiUrl_prod'
export { default as OVERAGES_URL } from './OveragesApiUrl_prod'
export { default as PAYMENTS_URL } from './PaymentsApiUrl_prod'
export { default as SHORTENER_URL } from './ShortenerUrl_prod'
export { default as VOICE_URL } from './VoiceApiUrl_prod'
